import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';

Logo.propTypes = {
  sx: PropTypes.object,
  isCollapse: PropTypes.bool,
};

export default function Logo({
  sx,
  isCollapse,
}: {
  sx?: object;
  isCollapse: boolean;
}) {
  return (
    <RouterLink to='/'>
      {isCollapse ? (
        <Box
          component='img'
          src='/static/adori-logo.png'
          alt='Adori'
          sx={{ width: 72, height: 'auto', ...sx }}
        />
      ) : (
        <Box
          component='img'
          src='/static/adori-logo.png'
          alt='Adori'
          sx={{ width: 120, height: 'auto', ...sx }}
        />
      )}
    </RouterLink>
  );
}
